import { DictType } from 'core-lib/types/Helper';
import { ProductDescriptionDataParent } from './index';
import Layout from './layout';
import { MutableRefObject } from 'react';

export enum ProductType {
  Simple = 'simple',
  Virtual = 'virtual',
  Bundle = 'bundle',
}

export enum SkuType {
  InternalVoucher = 'internal_voucher',
  ExternalVoucher = 'external_voucher',
  FuelVoucher = 'fuel_voucher',
}

export enum StoreType {
  ParkplusStore = 'parkplus_store',
  MlStore = 'ml_store',
}

interface Product {
  productId: number;
  parentId?: number;
  productSku: string;
  productType: ProductType;
  skuType: SkuType;
  price: number; // mrp
  discountedPrice: number; // price at which the product is sold without lp
  loyaltyPoints: number; // loyalty points applicable
  loyaltyPrice: number; // price after applying loyalty points
  stock: number; // actual stock
  virtualStock?: number; // stock to be shown to customer
  icon?: string;
  coverImage?: string;
  title?: string;
  subtitle1?: string;
  subtitle2?: string;
  tag?: string;
  priceNudge?: string;
  maxCartQuantity: number;
  rating?: string;
  filter?: DictType;
  suffix?: string;
  redirectionUrl?: string;
  productOption?: DictType;
  actualDiscountedPrice?: number;
  subCategoryId?: number;
  eventType?: string;
  videoUrl?: string;
  brandLogo?: string;
  offerText?: string;
  totalVotes?: number;
  slashPrice?: string;
}

export type ProductHighlight = {
  title: string;
  subtitle: string;
  icon: string;
};

export type ProductSummary = {
  title: string;
  content: HTMLElement;
  contentType: string;
  data: any;
};

export type FooterText = {
  title: string;
  color: string;
  icon?: string;
};

export interface ProductDescription extends Product {
  descriptionImages: string[];
  productHighlights: ProductHighlight[];
  productSummaries?: ProductSummary[];
  footerText?: FooterText;
  mlUsed: number;
  mlSavings: number;
  coverImageNudge?: string;
  priceNudge?: string;
  // eligible?: boolean;
  expiry?: string;
  video?: {
    thumbnail?: string;
    url: string;
  };
  configuration: configurationType;
  similarProducts?: Layout[];
  isGift?: boolean;
  pickUpPostCode: number;
  genericInfo?: GenericInfoType[];
}

export type GenericInfoType = {
  icon: string;
  text: string;
};

export type ProductCardProp = {
  product?: Product;
  fixedWidth?: boolean;
  isLoading?: boolean;
  isSmall?: boolean;
  section?: string;
  position?: number;
  productId?: number;
  id?: string;
  showNudge? : boolean;
  ref?: MutableRefObject<HTMLInputElement>;
  inViewPort?: boolean;
  activeIndex?: number;
};

export type ProductListing = {
  products: Product[];
  storeType: StoreType;
  nextPage: number;
  hasMore: boolean;
  totalCount: number;
  currentFilter: string;
};

export type ListingFilterSubcategoryItem = {
  id: string;
  filter: DictType;
  title: string;
  image: string;
};

export type ListingFilterSubcategory = {
  items: {
    [parentCategoryId: string]: ListingFilterSubcategoryItem[];
  };
  currentParentCategoryId: string;
};

export type PdpPropType = {
  data: ProductDescription;
  apiStatus?: String;
  updatePdpSlice?: (payload: ProductDescriptionDataParent) => void;
};

export type ProductFillCartType = {
  qty: number;
  sku: string;
  itemId?: number;
};
export enum DropDownContentType {
  TABLE = 'table',
  TEXT = 'text',
}

export type OptionsType = {
  isDefault: boolean;
  option: string;
  uiType: string;
  value: string;
};

export type VariantsType = {
  label: string;
  options: OptionsType[];
};

export type configurationType = {
  childProductId: DictType[];
  variants: VariantsType[];
};

export default Product;

export enum VariantUiType {
  CARD = 'CARD',
  CHIP = 'CHIP',
  CIRCLE = 'CIRCLE',
}

export interface ProductBoughtDataType {
  canReview: boolean;
}
